import { type Menu } from "@/stores/menu";

const menu: Array<Menu | "divider"> = [
  {
    icon: "Home",
    pageName: "dashboard",
    title: "Dashboard",
    subMenu: [
      {
        icon: "Activity",
        pageName: "dashboard-overview-3",
        title: "Overview 3",
      },
      {
        icon: "Activity",
        pageName: "dashboard-overview-4",
        title: "Overview 4",
      },
    ],
  },
  {
    icon: "ShoppingBag",
    pageName: "ecommerce",
    title: "E-Commerce",
    subMenu: [
      {
        icon: "Activity",
        pageName: "add-product",
        title: "Add Product",
      },
    ],
  },
  {
    icon: "MessageSquare",
    pageName: "chat",
    title: "Chat",
  },
  {
    icon: "FileText",
    pageName: "post",
    title: "Post",
  },
  "divider",
  {
    icon: "Layout",
    pageName: "layout",
    title: "Pages",
    subMenu: [
      {
        icon: "Activity",
        pageName: "wizards",
        title: "Wizards",
        subMenu: [
          {
            icon: "Zap",
            pageName: "wizard-layout-1",
            title: "Layout 1",
          },
          {
            icon: "Zap",
            pageName: "wizard-layout-2",
            title: "Layout 2",
          },
          {
            icon: "Zap",
            pageName: "wizard-layout-3",
            title: "Layout 3",
          },
        ],
      },
      {
        icon: "Activity",
        pageName: "blog",
        title: "Blog",
        subMenu: [
          {
            icon: "Zap",
            pageName: "blog-layout-1",
            title: "Layout 1",
          },
          {
            icon: "Zap",
            pageName: "blog-layout-2",
            title: "Layout 2",
          },
          {
            icon: "Zap",
            pageName: "blog-layout-3",
            title: "Layout 3",
          },
        ],
      },
      {
        icon: "Activity",
        pageName: "pricing",
        title: "Pricing",
        subMenu: [
          {
            icon: "Zap",
            pageName: "pricing-layout-1",
            title: "Layout 1",
          },
          {
            icon: "Zap",
            pageName: "pricing-layout-2",
            title: "Layout 2",
          },
        ],
      },
      {
        icon: "Activity",
        pageName: "invoice",
        title: "Invoice",
        subMenu: [
          {
            icon: "Zap",
            pageName: "invoice-layout-1",
            title: "Layout 1",
          },
          {
            icon: "Zap",
            pageName: "invoice-layout-2",
            title: "Layout 2",
          },
        ],
      },
      {
        icon: "Activity",
        pageName: "login",
        title: "Login",
      },
      {
        icon: "Activity",
        pageName: "error-page",
        title: "Error Page",
      },
      {
        icon: "Activity",
        pageName: "change-password",
        title: "Change Password",
      },
    ],
  },
  "divider",
  {
    icon: "Inbox",
    pageName: "components",
    title: "Components",
    subMenu: [
      {
        icon: "Activity",
        pageName: "overlay",
        title: "Overlay",
        subMenu: [
          {
            icon: "Zap",
            pageName: "modal",
            title: "Modal",
          },
          {
            icon: "Zap",
            pageName: "slide-over",
            title: "Slide Over",
          },
          {
            icon: "Zap",
            pageName: "notification",
            title: "Notification",
          },
        ],
      },
      {
        icon: "Activity",
        pageName: "tab",
        title: "Tab",
      },
      {
        icon: "Activity",
        pageName: "alert",
        title: "Alert",
      },
      {
        icon: "Activity",
        pageName: "progress-bar",
        title: "Progress Bar",
      },
      {
        icon: "Activity",
        pageName: "tooltip",
        title: "Tooltip",
      },
      {
        icon: "Activity",
        pageName: "icon",
        title: "",
      },
      {
        icon: "Activity",
        pageName: "loading-icon",
        title: "Loading ",
      },
    ],
  },
  {
    icon: "Sidebar",
    pageName: "forms",
    title: "Forms",
    subMenu: [
      {
        icon: "Activity",
        pageName: "regular-form",
        title: "Regular Form",
      },
      {
        icon: "Activity",
        pageName: "file-upload",
        title: "File Upload",
      },
      {
        icon: "Activity",
        pageName: "validation",
        title: "Validation",
      },
    ],
  },
  {
    icon: "HardDrive",
    pageName: "widgets",
    title: "Widgets",
    subMenu: [
      {
        icon: "Activity",
        pageName: "slider",
        title: "Slider",
      },
    ],
  },
];

export default menu;
